import { Routes } from "@angular/router";
import { CwtAuthGuard } from "@cawita/core-front/auth";

export default [
    { path: 'auth', canActivate: [CwtAuthGuard({ mustBeLoggedOut: true })], loadChildren: () => import('./auth/auth.routes') },
    { path: '', canActivate: [CwtAuthGuard({ accessTypes: 'admin' })], loadChildren: () => import('./main/main.routes') }
] as Routes;